<template>
  <main class="page-investors-index">
    <div class="container">
      <PageTitle class="mb-5">Investitori</PageTitle>
      <div class="row">
        <div class="col-lg-4 col-md-6" v-for="(investor, index) in investors" :key="index">
          <LawaCard :name="investor.name + ' ' + investor.surname"  class="h-100">
            <template #header>
              <p class="text-uppercase text-right mb-0">
                <span class="d-block small font-weight-light text-muted">Stato</span>
                <span :class="investor.signed ? (investor.disabled ? 'text-danger' : 'text-success') : 'text-warning'">
                  {{ investor.signed ? (investor.disabled ? 'Disattivo' : 'Attivo') : 'Invito inviato' }}
                </span>
              </p>
            </template>
            <div style="min-height: 100px;">
              <h4 class="font-weight-bold truncated-text pointer">
                {{ investor.signed ? investor.name + ' ' + investor.surname : 'In attesa di conferma' }}
              </h4>
              <p class="small text-uppercase mb-1">
                <strong>Email:</strong>
                {{ investor.email || 'email@prova.it' }}
              </p>
            </div>
            <template #footer>
              <AwlConfirm
                v-if="!investor.signed"
                class="btn btn-block text-left"
                status='outline-danger btn'
                title='Elimina invito'
                @confirm="deleteReservation(investor)"
              >
                Sei sicuro di voler eliminare l'invito per l'utente {{ investor.name }} {{ investor.surname }}
              </AwlConfirm>
              <button class="btn btn-block btn-primary align-self-center m-0" @click="resendEmail(investor)" v-if="!investor.signed">
                <i class="fas fa-share mr-1"></i>
                Rimanda invito
              </button>
            </template>
          </LawaCard>
        </div>
      </div>
      <div class="fab-container">
        <AwlFabAddButton class="ml-auto" @click="$refs['invite-investor-modal'].show()" />
      </div>

      <BModal title="Invita" dialog-class="modal--type-dialog" id="invite-investor-modal" ref="invite-investor-modal" hide-footer centered scrollable>
        <p>
          Invita un investor
          <br />
          Deve accettare il tuo invito per poter accedere alla piattaforma
        </p>
        <ReservationForm role="investor" @success="successForm" />
      </BModal>
    </div>
  </main>
</template>

<script>

import $api from '../../../../libs/Api/services/api';
import { BModal } from 'bootstrap-vue';

export default {
  name: 'page-investors-index',
  components: {
    BModal,
    AwlConfirm: () => import('../../../../libs/Modals/components/AwlConfirm'),
    AwlFabAddButton: () => import('../../../components/Ui/AwlFabAddButton'),
    ReservationForm: () => import('../../../components/Account/ReservationForm'),
    PageTitle: () => import('../../../components/Layout/LayoutOperative/PageTitle'),
    LawaCard: () => import('../../../components/Layout/Card/LawaCard'),
  },
  data () {
    return {
      investors: [],
    };
  },
  computed: {
    investorsTable () {
      const heading = [
        { key: 'name', label: 'Investor' },
      ];

      return {
        heading,
        rows: this.investors,
      };
    },
  },
  methods: {
    makeToast (variant = null, title = '', content = 'Successo') {
      this.$bvToast.toast(content, {
        title: title,
        toaster: 'b-toaster-top-right',
        solid: true,
        variant: variant,
        appendToast: true,
      });
    },
    async onConfirm (event, investor) {
      try {
        if (investor.disabled) {
          await this.$api.enableInvestor(investor.id);
        } else {
          await this.$api.disableInvestor(investor.id);
        }

        this.investors = (await this.$api.investors(true)).data?.investors || [];
      } catch (err) {
        this.$log.error(err);
      }
    },
    deleteReservation (investor) {
      this.$api.deleteUserReservation(investor.reservationId)
        .then(() => {
          this.makeToast('success', 'Invito eliminato', 'Invito correttamente eliminato');
        })
        .catch(err => {
          this.$log.error(err);
          this.makeToast('danger', 'Errore imprevisto', 'Errore nell\'eliminazione dell\'invito');
        }).finally(() => {
          this.$api.investors(true)
            .then(res => {
              this.investors = res.data?.investors || [];
            }).catch(err => {
              this.$log.error(err);
              this.makeToast('danger', 'Errore imprevisto', 'Errore nello scaricamento dei dati utente');
            });
        });
    },
    resendEmail (investor) {
      this.$api.reserveUser({ ...investor, role: 'investor' })
        .then(() => {
          this.makeToast('success', 'Invito inviato', `Email correttamente inviata a ${investor.email}`);
        }).catch(err => {
          this.$log.error(err);
        }).finally(() => {
          this.$api.investors(true)
            .then(res => {
              this.investors = res.data?.investors || [];
            }).catch(err => {
              this.$log.error(err);
            });
        });
    },
    async successForm () {
      this.$refs['invite-investor-modal'].hide();

      try {
        const res = await this.$api.investors(true);
        this.investors = res.data?.investors || [];
      } catch (error) {
        this.$log.error(error);
      }
    },
  },
  async beforeRouteEnter (to, from, next) {
    try {
      const res = await $api.investors(true);
      return next(vm => {
        vm.investors = res.data?.investors || [];
      });
    } catch (error) {
      return next(vm => vm.$log.error(error));
    }
  },
};

</script>

<style lang="scss">

.page-investors-index {
  .awl-card {
    .awl-card--content {
      padding-left: 0;
      padding-right: 0;
    }
  }
}

</style>
